import './FilterTag.scss';
import React from 'react';
import { Tag } from 'antd';
function getFilterLabel(value) {
    return `${value}:`;
}
export const FilterTag = ({ clearValue = null, id, format, label, update, value }) => {
    if (!value) {
        return null;
    }
    return (React.createElement(Tag, { className: 'data-dictionary-filter-tag', closable: true, onClose: () => {
            update({
                [id]: {
                    format,
                    value: clearValue
                }
            });
        } },
        React.createElement("span", { className: 'filter-label' }, getFilterLabel(label)),
        React.createElement("span", { className: 'filter-value' }, value)));
};
